export { POSE_IDS, type PoseId } from "./types";

export const AVATAR_SIZE = 192;
export const MAX_PAINT_MARKS = 5_600;
export const MAX_MARKS_PER_BRUSH_POINT = 6;
export const MAX_PAINT_COLORS = 16;
export const MAX_CUSTOM_PAINT_COLORS = 4;
